<template>
  <!-- Modal Overlay -->
  <div class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" @click="closeModal">
    <!-- Modal Container -->
    <div class="relative top-20 mx-auto p-5 border w-11/12 md:w-3/4 lg:w-1/2 shadow-lg rounded-md bg-white" @click.stop>
      <!-- Modal Header -->
      <div class="flex items-center justify-between pb-3 border-b border-gray-200">
        <h3 class="text-lg font-medium text-gray-900">
          Detalles de Inconformidad
        </h3>
        <button @click="closeModal" class="text-gray-400 hover:text-gray-600 transition-colors">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="py-4 space-y-4">
        <!-- Materia -->
        <div class="bg-gray-50 p-4 rounded-lg">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">Materia</h4>
          <p class="text-gray-900 font-medium">{{ disagreement.Materia }}</p>
        </div>

        <!-- Parcial -->
        <div class="bg-gray-50 p-4 rounded-lg">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">Parcial</h4>
          <p class="text-gray-900">{{ disagreement.Parcial }}</p>
        </div>

        <!-- Estatus -->
        <div class="bg-gray-50 p-4 rounded-lg">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">Estatus</h4>
          <span 
            class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium"
            :class="getStatusBadgeColor(disagreement.Estatus)"
          >
            <span 
              class="w-2 h-2 rounded-full mr-2"
              :class="getStatusIndicatorColor(disagreement.Estatus)"
            ></span>
            {{ getStatusText(disagreement.Estatus) }}
          </span>
        </div>

        <!-- Inconformidad -->
        <div class="bg-gray-50 p-4 rounded-lg">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">Descripción de la Inconformidad</h4>
          <p class="text-gray-900 leading-relaxed">{{ disagreement.Inconformidad }}</p>
        </div>

        <!-- Respuesta -->
        <div class="bg-gray-50 p-4 rounded-lg">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">Respuesta</h4>
          <p class="text-gray-900 leading-relaxed" v-if="disagreement.Respuesta">
            {{ disagreement.Respuesta }}
          </p>
          <p class="text-gray-500 italic" v-else>
            Sin respuesta disponible
          </p>
        </div>

        <!-- Fecha de Atención -->
        <div class="bg-gray-50 p-4 rounded-lg" v-if="disagreement.Atendido">
          <h4 class="text-sm font-semibold text-gray-700 mb-2">Fecha de Atención</h4>
          <p class="text-gray-900">{{ formatDate(disagreement.Atendido) }}</p>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="flex justify-end pt-4 border-t border-gray-200">
        <button 
          @click="closeModal"
          class="px-4 py-2 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisagreementDetails',
  props: {
    disagreement: {
      type: Object,
      required: true
    }
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close');
    },
    
    getStatusText(status) {
      const statusMap = {
        'pending': 'Pendiente',
        'resolved': 'Resuelta'
      };
      return statusMap[status] || status;
    },
    
    getStatusBadgeColor(status) {
      const colorMap = {
        'pending': 'bg-yellow-100 text-yellow-800',
        'resolved': 'bg-green-100 text-green-800'
      };
      return colorMap[status] || 'bg-gray-100 text-gray-800';
    },
    
    getStatusIndicatorColor(status) {
      const colorMap = {
        'pending': 'bg-yellow-400',
        'resolved': 'bg-green-400'
      };
      return colorMap[status] || 'bg-gray-400';
    },
    
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('es-MX', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  },
  mounted() {
    // Prevenir scroll del body cuando el modal está abierto
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    // Restaurar scroll del body cuando el modal se cierre
    document.body.style.overflow = 'auto';
  }
};
</script>